import axios from "axios"

const API_URL = process.env.API_ENDPOINT

const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${localStorage.access}`
  }
})

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${localStorage.access}`
  }
})

securedAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()
  if (method !== "OPTIONS" && method !== "GET") {
    config.headers = {
      ...config.headers,
      "X-CSRF-TOKEN": localStorage.csrf
    }
  }
  return config
})

securedAxiosInstance.interceptors.response.use(null, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    return plainAxiosInstance.post("/refresh", {}, { headers: { "X-CSRF-TOKEN": localStorage.csrf } })
      .then(response => {
        localStorage.csrf = response.data.csrf
        localStorage.access = response.data.access

        // And after successful refresh - repeat the original request
        let retryConfig = error.response.config
        retryConfig.headers["X-CSRF-TOKEN"] = localStorage.csrf
        return plainAxiosInstance.request(retryConfig)
      }).catch(error => {
        console.error(error)
        delete localStorage.csrf
        delete localStorage.access
        // redirect to signin in case refresh request fails
        location.replace("/")
        return Promise.reject(error)
      })
  } else {
    return Promise.reject(error)
  }
})

export { securedAxiosInstance, plainAxiosInstance }



// WEBPACK FOOTER //
// ./src/backend/axios/index.js